import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "form-label"
};
var _hoisted_2 = ["accept"];
var _hoisted_3 = {
  key: 0,
  "class": "p-2"
};
var _hoisted_4 = {
  key: 1,
  "class": "flex items-center justify-between p-2"
};
var _hoisted_5 = {
  "class": "flex-1 pr-1"
};
var _hoisted_6 = {
  "class": "text-gray-500 text-xs"
};
var _hoisted_7 = {
  key: 1,
  "class": "form-error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [$props.label ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString($props.label) + ":", 1)) : _createCommentVNode("", true), _createElementVNode("div", {
    "class": _normalizeClass(["form-input p-0", {
      error: $props.errors.length
    }])
  }, [_createElementVNode("input", {
    ref: "file",
    type: "file",
    accept: $props.accept,
    "class": "hidden",
    onChange: _cache[0] || (_cache[0] = function () {
      return $options.change && $options.change.apply($options, arguments);
    })
  }, null, 40, _hoisted_2), !$props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("button", {
    type: "button",
    "class": "px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.browse && $options.browse.apply($options, arguments);
    })
  }, "Browse")])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString($props.modelValue.name) + " ", 1), _createElementVNode("span", _hoisted_6, "(" + _toDisplayString($options.filesize($props.modelValue.size)) + ")", 1)]), _createElementVNode("button", {
    type: "button",
    "class": "px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.remove && $options.remove.apply($options, arguments);
    })
  }, "Remove")]))], 2), $props.errors.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.errors[0]), 1)) : _createCommentVNode("", true)]);
}